

export default function Hero() {
    return (
        <div className="relative overflow-hidden bg-gradient-to-br from-gray-900
         via-gray-800 to-gray-900">
            {/* Pattern décoratif */}
            <div className="absolute inset-0 opacity-5">
                <div className="absolute top-0 -right-40 w-80 h-80 bg-white rounded-full blur-3xl" />
                <div className="absolute bottom-0 -left-40 w-80 h-80 bg-white rounded-full blur-3xl" />
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] border border-white/10 rounded-full" />
            </div>

            <div className="relative container mx-auto px-4 py-20 md:py-28 text-center">
             

                <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 animate-in slide-in-from-bottom-5 duration-500 delay-100">
                    Toutes nos catégories
                </h1>

                <p className="text-gray-300 text-lg md:text-xl max-w-2xl mx-auto mb-8 animate-in slide-in-from-bottom-5 duration-500 delay-200">
                    Explorez notre large gamme de produits et trouvez exactement ce qu'il vous faut
                </p>

            
            </div>

            {/* Vague décorative */}
            <div className="absolute bottom-0 left-0 right-0">
                <svg viewBox="0 0 1440 80" className="w-full" preserveAspectRatio="none">
                    <path fill="#ffffff" d="M0,40 C240,80 480,0 720,40 C960,80 1200,0 1440,40 L1440,80 L0,80 Z" />
                </svg>
            </div>
        </div>
    )
}
